import angular from 'angular';

class listWorkflowsCtrl {
  /*  @ngInject */
  constructor($state, logger, PrePasrelSvc, AuthSvc) {
    this.$state = $state;
    this.logger = logger;
    this.PrePasrelSvc = PrePasrelSvc;
    this.AuthSvc = AuthSvc;
  }

  $onInit() {
    this.search = { name: '' };
    this.workflowsPromise = null;
    this.workflows = null;
    this.workflowsPromise = this.PrePasrelSvc.listWorkflows();
    this.workflowsPromise.then(
      workflows => {
        this.workflows = workflows;
      },
      (/*error*/) => {
        this.logger.error('error.generic');
      }
    );
  }

  editWorkflow(name) {
    this.$state.go('app.prepasrel.edit-workflow', { name: name });
  }

  newWorkflow() {
    this.$state.go('app.prepasrel.new-workflow');
  }

  canCreateNewWorkflow() {
    return this.AuthSvc.isAuthorized('CONFIGURATOR');
  }
}

angular.module('app.prepasrel').component('listWorkflows', {
  templateUrl: require('./list-workflows.html'),
  controller: listWorkflowsCtrl,
  bindings: {}
});
